<template>
    <div
        ref="widgetRef"
        class="widget-card"
    >
        <slot></slot>
        <div :id="teleportId" />
    </div>
</template>

<script setup lang="ts">
import { useEventBus } from '@vueuse/core'
import { provide, ref, useId } from 'vue'
import { type Breakpoint, installBreakpoints } from 'widget-components/composables/breakpoints'
import { TELEPORT_ID_KEY } from 'widget-components/composables/teleport/consts'

const widgetRef = ref<HTMLDivElement>()
const { update } = installBreakpoints(widgetRef)

useEventBus<Breakpoint>('breakpoint-updated').on((breakpoint) => update(breakpoint))

const teleportId = useId()
provide(TELEPORT_ID_KEY, teleportId)
</script>

<style lang="sass" scoped>
.widget-card
    --tl-wc-card-width: 420px
    position: relative
    background-color: var(--tl-widget-background-color)
    width: var(--tl-wc-card-width)
    height: 100%
    max-height: 580px
    border-radius: 22px
    overflow: hidden
    display: flex
    flex-flow: column
    transition: 0s
    box-shadow: 0 10px 50px -20px rgba(0, 0, 0, 0.3)

    @media (max-width: 460px)
        max-height: none
</style>
